import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation, } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { geolocalizationService } from '@core/services/geolocalization';
import { filter, Subscription } from 'rxjs';
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';
import { environment } from 'environments/environment';

@Component({
  selector: "config-menu-cb",
  templateUrl: "./config-menu-cb.component.html",
  styleUrls: ["./config-menu-cb.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class cbConfigMenuComponent implements OnInit, OnDestroy {
  /**
   * Constructor
   */
  constructor(
    private _geoS: geolocalizationService,
    private _router: Router,
    private _mStorage: manageStorageService,
  ) { }
  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------  
  dExecutive: any = {};
  linkActive: Array<boolean> = [false, false, false];
  role = this._mStorage.getPropertie('s_userSession')?.rol;
  subscriber: Subscription;

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
  ngOnInit(): void {

    this.setPathActive(this._router.url.split("/").pop());

    this.subscriber = this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (event['url'].includes('configuracion')) {
        let path = event['url'].split('/').pop();
        this.setPathActive(path)
      } else { this.linkActive = [false, false, false]; }
    });

  }
  ngOnDestroy() {
    this.subscriber?.unsubscribe();
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  listaNodos: any[] = [
    {
      descripcion: 'Cambio de contraseña',
      descripcionState: 'Modifica tu contraseña de ingreso',
      type: 'basic',
      icon: 'heroicons_outline:lock-closed',
      link: '/configuracion/cambioContrasena',
      hide: false,
      classes: {
        icon: 'icon-size-3',
      },
      codeScreen: "110110"
    },
    {
      descripcion: 'Cambio de clave de operación',
      descripcionState: 'Modifica tu clave de operación',
      type: 'basic',
      icon: 'heroicons_outline:hashtag',
      link: '/configuracion/claveOperativa',
      hide: this.role == '2' ? false : true,
      classes: {
        icon: 'icon-size-3',
      },
      codeScreen: "110140"
    },
    {
      descripcion: 'Envío electrónico del estado de cuenta',
      descripcionState: 'Recibe tu estado de cuenta por correo electrónico',
      type: 'basic',
      icon: 'heroicons_outline:mail',
      link: '/configuracion/edoCuentaDigital',
      hide: false,
      classes: {
        icon: 'icon-size-3',
      },
      codeScreen: "110150"
    },

  ];

  goLink(url) {
    this._geoS.putGeoInWS(url.codeScreen)
    this._router.navigate([url.link])
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  private setPathActive(path: string) {
    switch (path) {
      case 'cambioContrasena':
        this.linkActive = [true, false, false];
        break;
      case 'claveOperativa':
        this.linkActive = [false, true, false];
        break;
      case 'edoCuentaDigital':
        this.linkActive = [false, false, true];
        break;
    }
  }
}
